import React from "react"
import * as styles from "./Styles/Section.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const Section = (props) => {
  return (
    <div
      className={cn(
        "sectionHeader",
        props.withBottomPadding ? "withBottomPadding" : ""
      )}
    >
      {props.children}
    </div>
  )
}

export default Section
